// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__GlEeE","rootSuccess":"CompleteLink_rootSuccess__1XXl1","rootFailure":"CompleteLink_rootFailure__PjBLz","isDisabled":"CompleteLink_isDisabled__1a7kO"};